// Multi-segment circular progress ring (LeetCode "solved" donut).
// segments: [{ value, color }]. Draws colored arcs proportional to value,
// with the remainder shown as a track. Center content passed as children.
const ProgressRing = ({
  size = 176,
  stroke = 11,
  segments = [],
  total,
  trackColor = "var(--ring-track)",
  children,
}) => {
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const sumValues = segments.reduce((s, seg) => s + (seg.value || 0), 0);
  const denom = total || sumValues || 1;
  const gap = segments.filter((s) => s.value > 0).length > 1 ? 3 : 0;

  let start = 0;

  return (
    <div className="progress-ring" style={{ width: size, height: size }}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <g transform={`rotate(-90 ${size / 2} ${size / 2})`}>
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="none"
            stroke={trackColor}
            strokeWidth={stroke}
          />
          {segments.map((seg, i) => {
            if (!seg.value) return null;
            const arc = Math.max((seg.value / denom) * circumference - gap, 0);
            const dashoffset = -start;
            start += (seg.value / denom) * circumference;
            return (
              <circle
                key={i}
                cx={size / 2}
                cy={size / 2}
                r={radius}
                fill="none"
                stroke={seg.color}
                strokeWidth={stroke}
                strokeLinecap="round"
                strokeDasharray={`${arc} ${circumference}`}
                strokeDashoffset={dashoffset}
                style={{ transition: "stroke-dasharray .6s ease" }}
              />
            );
          })}
        </g>
      </svg>
      <div className="progress-ring-center">{children}</div>
    </div>
  );
};

export default ProgressRing;
